import styled from "styled-components";

export const Content = styled.main`
    padding: var(--spacing) calc(var(--spacing) * 2);
`;